"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrillSelectListBody = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var DrillSelectList_1 = require("./DrillSelectList");
exports.DrillSelectListBody = function (props) {
    var items = props.items, onSelect = props.onSelect;
    var stopPropagation = function (e) {
        e.stopPropagation();
    };
    return (react_1.default.createElement("div", { className: "gd-drill-modal-picker-dropdown s-drill-item-selector-dropdown", onScroll: stopPropagation },
        react_1.default.createElement("div", { className: "gd-drill-modal-picker-body" },
            react_1.default.createElement(DrillSelectList_1.DrillSelectList, { items: items, onSelect: onSelect }))));
};
//# sourceMappingURL=DrillSelectListBody.js.map